<template>
  <div class="scrollable">
    <v-container class="pa-md-6 pa-3">
      <v-row>
        <v-col>
          <v-card class="mx-auto pa-md-3" style="max-width: 1200px">
            <v-container
              :class="{ 'article-block': true, header: articleBlock.name.includes('Header'), content: !articleBlock.name.includes('Header') }"
              v-for="articleBlock of articleBlocks"
              :key="articleBlock.id"
            >
              <v-row v-for="articleRow of articleRows(articleBlock.children)" :key="articleRow.id">
                <v-col v-for="articleCol of articleCols(articleRow.children)" :key="articleCol.id" cols="12" :md="12 / articleRow.children.length">
                  <div
                    v-for="articleItem of articleItems(articleCol.children)"
                    :key="articleItem.id"
                    style="border-radius: 10px; overflow: hidden"
                    :class="{ 'article-element': true, 'lighten-4': articleItem.type === 'IMAGE' }"
                  >
                    <v-img
                      v-if="articleItem.type === 'IMAGE' && articleBlock.name.includes('Header')"
                      class="article-image header mx-auto"
                      width="100%"
                      :aspect-ratio="2.35 / 1"
                      :src="articleMediaUrl(articleMedia(articleItem.idMediaFk).properties)"
                    ></v-img>
                    <v-img
                      v-else-if="articleItem.type === 'IMAGE'"
                      class="article-image mx-auto"
                      width="100%"
                      contain
                      :src="articleMediaUrl(articleMedia(articleItem.idMediaFk).properties)"
                    ></v-img>
                    <div v-if="articleItem.type === 'VIDEO'" class="article-video">
                      <video width="100%" height="auto" class="mx-auto" controls>
                        <source :src="articleMediaUrl(articleMedia(articleItem.idMediaFk).properties)" />
                      </video>
                    </div>
                    <div v-if="articleItem.type === 'AUDIO'" class="article-audio">
                      <audio width="100%" height="auto" class="mx-auto" controls>
                        <source :src="articleMediaUrl(articleMedia(articleItem.idMediaFk).properties)" />
                      </audio>
                    </div>
                    <div
                      v-if="articleItem.type === 'TEXT' && !articleItem.properties.isTitle"
                      class="article-text text-body-1 mx-auto"
                      v-html="articleItem.properties.text"
                    ></div>
                    <div
                      v-if="articleItem.type === 'TEXT' && articleItem.properties.isTitle"
                      class="article-title text-h5 mx-auto"
                      v-html="articleItem.properties.text"
                    ></div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-card-subtitle v-if="description.length > 0" class="text-center">
              {{ description }}
            </v-card-subtitle>
            <v-card-text v-if="tags.length > 0" class="text-center">
              <span v-for="(tagId, i) in tags" :key="i">
                <v-chip v-if="tagsById[tagId]" class="mr-1" small>{{ tagsById[tagId].name }}</v-chip>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import index from '../index';
import common from '@/mixins/common';
import { mapState } from 'vuex';

const ARTICLE_TYPES = ['TEXT', 'IMAGE', 'VIDEO', 'AUDIO'];

export default {
  name: 'ArticleViewer',
  emits: [],
  mixins: [common],
  components: {},
  props: {
    container: {
      type: Object,
      default: () => {},
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('media', ['containersById', 'mediasById', 'tagsById']),
    articleBlocks() {
      const blocks = [];
      if (!this.container.children) return blocks;

      for (const childId of this.container.children) {
        const container = this.containersById[childId];
        if (!container || container.type !== 'BLOCK' || !container.properties || !container.properties.show) continue;
        blocks.push(container);
      }

      return blocks;
    },
    mediaProperties() {
      return this.media.properties;
    },
    mediaFileName() {
      return this.mediaProperties.filename || '';
    },
    mediaChecksum() {
      return this.mediaProperties.checksum || '';
    },
    mediaMimeType() {
      return this.mediaProperties.mimetype || '';
    },
    mediaUrl() {
      return this.moduleFileUrl(index.moduleId, this.mediaFileName, this.mediaChecksum);
    },
    properties() {
      return this.container.properties ? this.container.properties : {};
    },
    description() {
      return this.properties.description ? this.properties.description : '';
    },
    tags() {
      return this.container.tags && Array.isArray(this.container.tags) ? this.container.tags : [];
    },
  },
  methods: {
    articleRows(rowIds) {
      return rowIds.map((rowId) => this.containersById[rowId]).filter((container) => container && container.type === 'ROW');
    },

    articleCols(colIds) {
      return colIds.map((colId) => this.containersById[colId]).filter((container) => container && container.type === 'COL');
    },

    articleItems(itemIds) {
      return itemIds.map((itemId) => this.containersById[itemId]).filter((container) => container && container.type && ARTICLE_TYPES.includes(container.type));
    },

    articleMedia(mediaId) {
      return this.mediasById[mediaId] ?? {};
    },

    articleMediaUrl(mediaProperties) {
      return this.moduleFileUrl(index.moduleId, mediaProperties.filename, mediaProperties.checksum);
    },
  },
};
</script>
<style>
.article-text p:last-child {
  margin-bottom: 0 !important;
}
.article-text ul:not(:last-child) {
  margin-bottom: 12px;
}
.article-block.content .article-title {
  margin-bottom: 24px;
}
.article-element:not(:first-child) .article-image:not(.header) {
  margin-top: 24px;
}
.article-element:not(:last-child) .article-image:not(.header) {
  margin-bottom: 24px;
}
</style>
<style scoped>
.text-h5 {
  line-height: 1 !important;
}
.row > div > div:last-child > .text-h5 {
  padding-top: 24px;
}
@media screen and (max-width: 960px) {
  .row > div > div:last-child > .text-h5 {
    padding-top: 12px;
  }
}
video {
  display: block;
  width: 100%;
}
</style>
